import StarIcon from "../icons/StarIcon";

const RatingStars = ({stars=5,rating=0}) => {
    return (
        <div className="flex flex-nowrap flex-row-reverse justify-end">
            {Array.from({length: stars}, (_, i) => i+1).map((star, index) => {
                return (
                    <StarIcon key={`star-${index}`} isActive={index+1 <= rating} />
                )
            })}
        </div>
    )
}
export default RatingStars;